<template>
  <div>
    <el-upload
      multiple
      :disabled="disabled"
      :show-file-list="showFileList"
      :on-change="handleChange"
      :auto-upload="true"
      :options="options"
      :http-request="checkedFile"
      :before-remove="removeFile"
      :limit="limit"
      :on-exceed="handleExceed"
      v-bind="$attrs"
      :file-list.sync="fileList"
      :action="action"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      v-on="$listeners"
    >
      <slot name="btn">
        <el-button v-show="!disabled" size="small" type="primary" icon="el-icon-circle-plus-outline">添加</el-button>
      </slot>
      <div v-if="tip&&!disabled" slot="tip" class="el-upload__tip">{{ tip }}</div>
      <template v-if="showFileList" slot="file" slot-scope="{file}">
        <slot :file="file" name="file">
          <div
            class="um-filebox"
            :class="{
              fail:file.status === 'fail'
            }"
          >
            <div class="type">
              <svg-icon v-if="file.fileExtension==='zip'" icon-class="file_zip" />
              <svg-icon v-else-if="file.fileExtension==='xls'" icon-class="file_xls" />
              <svg-icon v-else icon-class="file_jpg" />
            </div>
            <div class="info">
              <div class="title" @click="handleClick(file)"><el-link style="font-weight: normal;">
                <span style="display: inline-block;max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ file.fileName||file.name }}</span>
              </el-link></div>
              <div v-if="file.size" class="size">{{ file.size |calFileSize }}</div>
              <div class="more">
                {{ file.uploadTime }} {{ file.uploadUserName }} <template v-if="file.uploadUserDesc">{{ '-'+file.uploadUserDesc }}</template>
              </div>
              <svg-icon v-if="!disabled" icon-class="close" class="close" @click="handleRemove(file)" />
              <el-progress
                v-if="file.status === 'uploading'"
                class="progress"
                type="line"
                :stroke-width=" 2"
                :percentage="parsePercentage(file.percentage)"
              />
              <el-button v-if="file.status === 'fail'" size="mini" style="padding:4px 8px;" @click="reload(file)">重新上传</el-button>
            </div>
          </div>

        </slot>
      </template>
    </el-upload>
  </div>
</template>

<script>
// 格式化文件大小
function calFileSize(value) {
  if (value === null || value === '') {
    return '0 Bytes'
  }
  var unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var srcsize = parseFloat(value)
  var index = Math.floor(Math.log(srcsize) / Math.log(1024))
  var size = srcsize / Math.pow(1024, index)
  //  保留的小数位数
  size = size.toFixed(2)
  return size + unitArr[index]
}

import { getToken } from '@/utils/auth'
import Locale from 'element-ui/src/mixins/locale'
import ElProgress from 'element-ui/packages/progress'
import Upload from './upload'
import emitter from 'element-ui/src/mixins/emitter'
export default {
  name: 'UmUpload',
  components: { ElProgress },
  filters: {
    calFileSize: calFileSize
  },
  mixins: [Locale, emitter],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 是否显示文件列表
    showFileList: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 0
    },
    // 抛出表单验证
    validateEvent: {
      type: Boolean,
      default: true
    },
    readOnly: { // 限制用户是否可以预览
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      token: getToken(),
      options: {},
      fileList: [],
      progressPercent: 0,
      progressFlag: false
    }
  },
  computed: {
    action() {
      return '/api/merchant/pfile/g/system/upload/resource/v2'
    }
  },
  watch: {
    value: {
      handler(val, oldValue) {
        // 当用户关闭弹框的时候会初始化文件上传
        // 判定undefined 排除初始化空数组问题
        if (val.length === 0 && oldValue !== undefined) {
          this.fileList.forEach(file => {
            file.$upload && file.$upload.remove && file.$upload.remove()
          })
          this.fileList = []
        }
        console.log(val, oldValue)
        if (Array.isArray(val)) {
          // 处理回显问题
          val.forEach(item => {
            if (!item.filePath && item.fileHttpPath) {
              item.filePath = item.fileHttpPath
            }
          })
          const list = this.fileList.filter(item => item.filePath || item.fileHttpPath)
          if (val.length !== list.length) {
            this.fileList = val
          }
        } else {
          this.fileList = []
        }
      },
      immediate: true
    },
    fileList(val) {
      const list = val.filter(item => item.filePath || item.fileHttpPath)

      if (JSON.stringify(this.value) === JSON.stringify(list)) {
        return false
      }

      this.$emit('change', list)
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [list])
      }
    }
  },
  methods: {
    reload(file) {
      file.status = 'uploading'
      file.$upload && file.$upload.reload()
    },
    parsePercentage(val) {
      return parseInt(val, 10)
    },
    handleClick(file) {
      if (this.readOnly) return false
      this.handlePreview && this.handlePreview(file)
    },
    // 上传限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 预览文件
    handlePreview(file, fileList) {
      if (file.fileHttpPath) {
        window.open(file.fileHttpPath)
      } else {
        window.open(file.filePath)
      }
    },
    // 移除文件
    handleRemove(file, fileList) {
      // debugger
      // this.fileList = fileList || []
      this.fileList.splice(this.fileList.indexOf(file), 1)
      file.$upload && file.$upload.remove && file.$upload.remove()
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handleChange(file, fileList) {
    },
    // 覆盖默认的上传行为，可以自定义上传的实现
    checkedFile(res) {
      console.log(res)
      // eslint-disable-next-line no-unused-vars
      const { file, action, onProgress } = res
      // 后期需要自己单独生成
      // const uid =  file.uid
      const item = {}
      item.name = file.name
      item.percentage = 0
      item.raw = file
      item.size = file.size
      item.status = 'ready'
      item.uid = file.uid

      const $upload = new Upload({
        file,
        action,
        onProgress: function(rate) {
          // 上传进度
          console.log(rate)
          if (item.status === 'fail') return false
          item.status = 'uploading'
          item.percentage = rate > 100 ? 100 : rate
        },
        piece: 1024 * 1024 * 10, // 切片大小
        onSuccess: (file) => {
          const { fileName, filePath, fileFullPath, fileType } = file
          item.status = 'success'
          item.percentage = 100
          this.$set(item, 'fileName', fileName)
          this.$set(item, 'filePath', filePath)
          this.$set(item, 'fileHttpPath', fileFullPath)
          this.$set(item, 'fileExtension', fileType)
        },
        onFail: () => {
          item.status = 'fail'
          this.$message.error('上传失败！')
        }
      })
      item.$upload = $upload
      this.fileList.push(item)
    },

    // 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
    removeFile(file) {}
  }
}
</script>

<style scoped lang="scss">
  .el-upload__tip{
    line-height: 1.4;
  }
  .um-filebox{
    padding:5px 10px;
    border-radius: 2px;
    border: 1px dashed #DFE0E2;
    position: relative;
    min-width: 280px;
    text-align: left;
    &.fail{
      border:1px dashed red;
    }
    &:after{
      content: '';
      display: block;
      clear: both;
    }
    .progress{
      position: absolute;
      left:5%;
      width: 90%;
      bottom:0;
      top:auto;
    }
    .type{
      float: left;
      width: 50px;
      margin-right: -50px;
      line-height: 1;
      font-size: 50px;
    }
    .info{
      margin-left: 60px;
    }
    .close{
      position: absolute;
      top:8px;
      right:8px;
      z-index: 2;
      font-size: 14px;
      color:#9F9FB7;
    }
  }
  ::v-deep .el-upload-list__item{
    margin-bottom: 10px;
  }
</style>
